import { Direction, Position } from '../types'

/**
 * Calculates the direction of a swipe based on the difference of the startPos
 * and newPos positions.
 */
export default function calculateDirection(startPos: Position, newPos: Position): Direction {
	const xDiff = newPos.x - startPos.x
	const yDiff = newPos.y - startPos.y

	// Angle goes from 0 - 360, where 0 is directly left/west
	let angle = Math.atan2(yDiff, xDiff) * (180 / Math.PI)
	angle += 180
	let dir: Direction = 'l'
	if (angle >= 22.5 && angle < 67.5) dir = 'ul'
	else if (angle >= 67.5 && angle < 112.5) dir = 'u'
	else if (angle >= 112.5 && angle < 157.5) dir = 'ur'
	else if (angle >= 157.5 && angle < 202.5) dir = 'r'
	else if (angle >= 202.5 && angle < 247.5) dir = 'dr'
	else if (angle >= 247.5 && angle < 292.5) dir = 'd'
	else if (angle >= 292.5 && angle < 337.5) dir = 'dl'
	return dir
}
